<template lang="pug">
#officeContainer(v-loading='loading'
  element-loading-text='文档加载中...'
  element-loading-background='rgba(244, 245, 250, 1)')
  iframe.iframe(ref='iframeID')
  application(ref='docApplication' type="office" v-if="docloaded")
</template>

<script>
import { creatWatermarkUserInfo, addWaterMarker, clearWaterMarker } from "@/CommonDP/mongeView/utils";
import mongeService from "@/CommonDP/mongeView/service/monge-service.js";
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
import application from "@/CommonDP/mongeView/appView/applicationH5.vue";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
export default {
  components: { application },
  data () {
    return {
      loading: true,
      docloaded: false
    };
  },
  computed: {
    docmentData() {
      return JSON.parse(mongeApp.other.fileInfo);
    }
  },
  created () {
    this.getFileInfo();
  },
  beforeDestroy(){
    clearWaterMarker(document.body);
  },
  methods: {
    async getFileInfo() {
      const { fileId, versionIds: fileVersion, sharerId = "", i = "" } = this.$route.query;
      mongeMutations.setShareId(i);
      if (!fileId) {
        return Promise.reject("没有文件id，无法获取文件信息");
      }
      const { data } = await mongeService.getFileDetails(fileId, i);
      document.title = data.fileName;
      const urlData = {
        fileId,
        fileName: encodeURIComponent(data.fileName),
        prjId: data.prjId,
        fileVersion
      };
      mongeMutations.setDocmentView(JSON.stringify(urlData));
      await mongeApiMlib.initEvent();
      await this.getRequestData(sharerId);
    },
    async getRequestData(sharerId) {
      const domBox = this.$refs.iframeID;
      domBox.onerror = () => {
        this.loadingTxt = '文档加载失败';
      };
      domBox.onload = () => {
        this.loading = false;
        this.docloaded = true;
        // 加水印
        addWaterMarker(document.body, creatWatermarkUserInfo());
      };
      try {
        console.log(2222222,this.docmentData);
        const otherData = this.docmentData;
        const result = await mongeService.getoffice(otherData.fileId, otherData.fileVersion);
        domBox.src = result.data;
      } catch (e) {
        this.$message.warning('office地址获取失败');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
#officeContainer{
  width: 100%;
  height: 100%;
  position: relative;
  .iframe{
    padding-top: 46px;
    position: absolute;
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
